"use client";

import { useState, useEffect } from "react";

/**
 * Platform detection hook.
 */
export function usePlatform() {
  const [state, setState] = useState<boolean | null>(null);

  useEffect(() => {
    const checkMobile = () => {
      // TODO: Capacitor mobile features — uncomment when launching mobile builds
      // const isNative =
      //   typeof window !== "undefined" &&
      //   (window as any).Capacitor?.isNativePlatform?.();

      // Check viewport width
      setState(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return { isMobile: state ?? false, isReady: state !== null };
}
